module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0018.jpg?v=cd116dfa";